import { getLocatorFromOdspUrl, OdspFluidDataStoreLocator } from '@fluidframework/odsp-driver';

export function getDriverDetailsForFluidItem(documentUrl: string): OdspFluidDataStoreLocator {
    const driverDetails = getLocatorFromOdspUrl(new URL(documentUrl));
    return driverDetails;
}
